import {
  LOAD_DISTRIBUTORS,
  CREATE_DISTRIBUTOR,
  LOAD_DISTRIBUTOR,
  EDIT_DISTRIBUTOR,
  DELETE_DISTRIBUTOR,
  UPLOAD_FILE,
  DOWNLOAD_FILE,
  DESTROY_MANY
} from "./actions";

const initialState = {
  message: "",
  data: [],
  distributor: { distributor_code: "", distributor_name: "" },
  alertMessage: "",
  errorMessage: "",
  totalSize: 0,

  errorImport: "",
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DISTRIBUTORS.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case LOAD_DISTRIBUTORS.SUCCESS:
      return {
        ...state,
        data: action.payload.distributors.data,
        totalSize: action.payload.distributors.total_row,
        alertMessage: "",
        errorMessage: "",
        distributor: initialState.distributor,

        errorImport: "",
        loading: false
      };
    case LOAD_DISTRIBUTOR.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case LOAD_DISTRIBUTOR.SUCCESS:
      return {
        ...state,
        distributor: action.payload.distributor.data,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case CREATE_DISTRIBUTOR.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case CREATE_DISTRIBUTOR.SUCCESS:
      return {
        ...state,
        alertMessage: action.payload.distributor.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case CREATE_DISTRIBUTOR.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        alertMessage: "",

        errorImport: "",
        loading: false
      };
    case EDIT_DISTRIBUTOR.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case EDIT_DISTRIBUTOR.SUCCESS:
      return {
        ...state,
        alertMessage: action.payload.distributor.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case EDIT_DISTRIBUTOR.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        alertMessage: "",

        errorImport: "",
        loading: false
      };
    case DELETE_DISTRIBUTOR.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };

    case DELETE_DISTRIBUTOR.SUCCESS:
      const newDistributors = state.data.filter(
        distributor =>
          distributor.distributor_id !==
          action.payload.distributor.data.distributor_id
      );
      return {
        ...state,
        data: newDistributors,
        alertMessage: action.payload.distributor.message,
        totalSize: state.totalSize - 1,

        errorImport: "",
        loading: false
      };
    case DELETE_DISTRIBUTOR.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        errorImport: "",
        loading: false
      };
    case UPLOAD_FILE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };
    case UPLOAD_FILE.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        totalSize: action.payload.data.total_row,
        alertMessage: action.payload.data.message,
        errorMessage: "",

        errorImport: "",
        loading: false
      };
    case UPLOAD_FILE.FAILURE:
      return {
        ...state,
        errorImport: action.payload.error,
        errorMessage: "",
        alertMessage: "",

        loading: false
      };
    case DOWNLOAD_FILE.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",

        errorImport: "",
        loading: true
      };
    case DOWNLOAD_FILE.SUCCESS:
      return {
        ...state,
        loading: false
      };
    case DOWNLOAD_FILE.FAILURE:
      return {
        ...state,
        loading: false
      };

    case DESTROY_MANY.REQUEST:
      return {
        ...state,
        alertMessage: "",
        errorMessage: "",
        loading: true
      };

    case DESTROY_MANY.SUCCESS:
      const { data } = action.payload.data;
      return {
        ...state,
        data: state.data.filter(val => !data.includes(val.distributor_id)),
        alertMessage: "success",
        totalSize: state.totalSize - 1,
        loading: false
      };

    case DESTROY_MANY.FAILURE:
      return {
        ...state,
        errorMessage: action.payload.error,
        loading: false
      };

    default:
      return state;
  }
};
